// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '../store/store'
import Vuetify from 'vuetify'
import axios from './plugins/axios'
import api from './api/api'
import helper from './Unit/helper'
import helpr from './components/helper/helper'
import notification from './Unit/notification'

var Rollbar = require('vue-rollbar');
Vue.use(Rollbar, {
     accessToken: 'd91bb006e709499ca064445709ac95c3',
     captureUncaught: true,
     captureUnhandledRejections: true,
     enabled: true,
     source_map_enabled: true,
     environment: 'production',
     payload: {
       client: {
            javascript: {
               code_version: '1.0'
            }
       }
     }
});

Vue.config.errorHandler = function(err, vm, info) {
  Vue.rollbar.error(err);
}

Vue.use(require('vue-moment'));

Vue.prototype.$multiCurrencies = process.env.MULTIVALUTE_MODE == 'on'
import filters from './filters/filters'
filters.forEach(f => {
  Vue.filter(f.name, f.execute)
})

Vue.prototype.$axios = axios;

//import * as moment from 'moment'
//Vue.prototype.$moment = moment;

Vue.use(Vuetify, {
  iconfont: 'fa4',
  theme: {
    primary: '#f44336', // #E53935
    secondary: '#f17a20', // 
    accent: '#f17a20 '// #3F51B5
  }
})
import 'vuetify/dist/vuetify.min.css'
//import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'font-awesome/css/font-awesome.min.css'

// import './assets/style/normalize.css'
import './assets/style/style.scss'
import './assets/style/animate.scss'

//include offline
import detectNetwork from 'v-offline';

Vue.component('detect-network', detectNetwork);

//include custom search-select
import searchSelect from './components/widgets/search-select/search-select'

Vue.component('search-select', searchSelect)
//include vuex
import Vuex from 'vuex';

Vue.use(Vuex);

Vue.prototype.$api = api

Vue.prototype.$helper = helper
Vue.prototype.$f = helpr

Vue.config.productionTip = false
//include i18n
import i18n from './local/i18n'

//include global bus
Vue.use({
  install: (Vue, options) => {
    Vue.prototype.$bus = new Vue()
  }
})

import 'vue-tel-input/dist/vue-tel-input.css';
import VueTelInput from 'vue-tel-input'

Vue.use(VueTelInput)

import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  i18n: i18n.i18n,
  components: {App},
  template: '<App/>',
  created() {
    let token = localStorage.getItem("user-token");
    if (token != null) {
      axios.defaults.headers.common["Authorization"] = token;
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js